export default __webpack_public_path__ + "static/Grupo-mascara-33a8176d02b057b33474bbd7af00a046.svg";